import { ZingChartComponent } from 'app/charts/components/base-classes/zing-chart';
import {
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { ColorThemeService } from 'app/common/services/color-theme.service';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import { PermissionTypes } from '@iv/store/permissions/permissions.models';
import {
  Subscription,
  timer
} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {PaymentWindowService} from '../../../payment-window.service';

@Component({
  selector: 'iv-live-abstract-skew-chart',
  template: '<ng-content></ng-content>'
})
export class SkewChartComponent extends ZingChartComponent implements OnInit, OnDestroy {

  constructor(
    protected readonly colorThemeService: ColorThemeService,
    @Inject(AppStore) protected readonly store: Redux.Store<AppState>,
    protected readonly paymentWindowService: PaymentWindowService
  ) {
    super(
      colorThemeService,
      store,
      paymentWindowService
    );
  }

  public noDataAvailable = false;
  public callActive = true;
  public putActive = true;
  protected ivCall: any[] = [];
  protected ivPut: any[] = [];

  protected minPercent = 0;
  protected maxPercent = 100;


  private intervalSubscription: Subscription;
  private _mode = null;
  public get mode(): string {
    return this._mode;
  }
  @Input()
  public set mode(value) {
    // TODO: предположительно здесь должно быть toUpperCase()
    this._mode = value.toLowerCase();
    this.isEOD = (this._mode === PermissionTypes.DELAYED_STOCKS || this._mode === PermissionTypes.EOD_FUTURES);
  }

  private _isEOD = true;
  public get isEOD(): boolean {
    return this._isEOD;
  }
  public set isEOD(value: boolean) {
    this._isEOD = value;
  }

  private _futureExpirationDate = '';
  public get futureExpirationDate() {
    return this._futureExpirationDate;
  }
  @Input()
  public set futureExpirationDate(value) {
    this._futureExpirationDate = value;
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.refreshByInterval(20);
  }

  public toggleChart(chart) {
    this[chart] = !this[chart];
    this.reRenderChart();
  }

  public switchMode() {
    this.isEOD = !this.isEOD;
    if (this.isEOD) {
      this.intervalSubscription.unsubscribe();
      this.getChartData();
    } else {
      this.isChartInitialized = false;
      this.refreshByInterval(20);
    }
  }

  private refreshByInterval(interval: number): void {
    this.intervalSubscription = timer(0 , interval * 1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.getChartData());
  }

  protected getPrefix() {
    if (this.tabType === 'future') return '';
    return (this.isEOD === true || (this.instrument && this.instrument.regionId !== 1)) ? '' : 'Rt';
  }
}
